/** @return {import("path")} */
const path = () => window.nodeModules?.path;

export default path;
